import React from 'react'
import PropTypes from 'prop-types'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBug, faRedo } from '@fortawesome/free-solid-svg-icons'
import { ActionButton } from 'shared/buttons'

// Failure state for the body of a dashboard/report card, so a chart, table or KPI that
// can't load says so in place instead of rendering an empty frame. Sibling of
// `shared/tables/table-error`, which fills a `<tbody>` row rather than a card body.
// `onRetry` is wired to the failing query's refetch where one is available.
//
// The underlying rejection is deliberately not shown: raw server and axios messages are
// meaningless to a municipality user. They still reach the console (react-query logs
// query failures; the direct apiGet callers log their own) for debugging.
function CardError({
  title = "Couldn't load this data",
  onRetry = null,
  isRetrying = false,
  minHeight = 200,
  className = ''
}) {
  return (
    <div
      className={`d-flex flex-column justify-content-center align-items-center text-center p-4 ${className}`.trim()}
      style={{ minHeight }}
      role="alert"
      data-testid="card-error"
    >
      <div className="text-danger mb-2">
        <FontAwesomeIcon icon={faBug} className="me-2" />
        {title}
      </div>
      {onRetry && (
        <ActionButton
          icon={faRedo}
          label="Try again"
          loading={isRetrying}
          loadingLabel="Retrying…"
          onClick={onRetry}
          variant="light"
          className="border text-primary"
        />
      )}
    </div>
  )
}

CardError.propTypes = {
  title: PropTypes.string,
  onRetry: PropTypes.func,
  isRetrying: PropTypes.bool,
  minHeight: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string
}

export default CardError
